import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { IDrugClass } from '@interfaces/lookups';
import { handleGetAdminDrugClasses } from '@store/features/adminDrugClasses/actions';
import {
  adminDrugClassesErrorSelector,
  adminDrugClassesIsLoadingSelector,
  adminDrugClassesIsReadySelector,
  adminDrugClassesSelector,
} from '@store/features/adminDrugClasses/selectors';
import { removeAdminDrugClasses } from '@store/features/adminDrugClasses/slice';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAdminDrugClassesByProgramCode = (programCode?: number): IDrugClass[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(adminDrugClassesSelector);
  const isLoading = useSelector(adminDrugClassesIsLoadingSelector);
  const isReady = useSelector(adminDrugClassesIsReadySelector);
  const error = useSelector(adminDrugClassesErrorSelector);

  const handleFetch = useCallback(() => {
    programCode && dispatch(handleGetAdminDrugClasses({ programCode }));
  }, [dispatch, programCode]);

  useEffect(() => {
    dispatch(removeAdminDrugClasses());
  }, [dispatch, programCode]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.adminDrugClassesError'),
    handleFetch,
  });

  return data;
};

export default useAdminDrugClassesByProgramCode;
